export default __webpack_public_path__ + "static/media/dark_left-arrow_icon.bed53d8d.svg";